import { DownChevronProps } from 'react-select/dist/declarations/src/components/indicators';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
interface DropdownChevronProps {
  menuIsOpen?: boolean;
  tabIndex?: number;
}

export const DropdownChevron = ({
  menuIsOpen,
  tabIndex,
}: DropdownChevronProps & DownChevronProps) =>
  menuIsOpen ? (
    <StyledIcon
      size="24px"
      className="uil uil-angle-down"
      tabIndex={tabIndex}
    />
  ) : (
    <StyledIcon size="24px" className="uil uil-angle-up" tabIndex={tabIndex} />
  );
